import { QuestionLanguage } from '@/resource/subject/subject.model';
import { Mark, markInputRule } from '@tiptap/core';

interface LanguageOptions {
  HTMLAttributes: Record<string, any>;
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    language: {
      /**
       * Set a language mark
       */
      setLanguage: () => ReturnType;
      /**
       * Toggle a language mark
       */
      toggleLanguage: (language: QuestionLanguage) => ReturnType;
      /**
       * Unset a language mark
       */
      unsetLanguage: () => ReturnType;
    };
  }
}

const starInputRegex = /(?:^|\s)((?:\*\*)((?:[^*]+))(?:\*\*))$/;
const underscoreInputRegex = /(?:^|\s)((?:__)((?:[^__]+))(?:__))$/;

const languageType = 'language';

const Language = Mark.create<LanguageOptions>({
  name: languageType,

  addOptions() {
    return {
      HTMLAttributes: {},
    };
  },

  parseHTML() {
    return [
      {
        tag: 'language',
      },
    ];
  },

  addAttributes() {
    return {
      language: {
        default: null,
      },
      hidden: {
        default: false,
      },
    };
  },

  renderHTML({ mark }) {
    const dom = document.createElement('span');

    if (mark.attrs.language) {
      const selectedLanguage = mark.attrs.language as QuestionLanguage;
      if (selectedLanguage === QuestionLanguage.english) {
        dom.classList.add('lang-english');
      } else {
        dom.classList.add('lang-malay');
      }
    }

    if (mark.attrs.hidden) {
      dom.classList.add('hidden');
    }

    return dom;
  },

  addCommands() {
    return {
      setLanguage: () => ({ commands }) => {
        return commands.setMark(this.name);
      },
      toggleLanguage: (language: QuestionLanguage) => ({ commands }) => {
        return commands.toggleMark(this.name, { language });
      },
      unsetLanguage: () => ({ commands }) => {
        return commands.unsetMark(this.name);
      },
    };
  },

  addInputRules() {
    return [
      markInputRule({
        find: starInputRegex,
        type: this.type,
      }),
      markInputRule({
        find: underscoreInputRegex,
        type: this.type,
      }),
    ];
  },
});

export default { mark: Language, type: languageType };
